<template>
  <div class="ps-app-mode-space">
    <!-- <dom-highlight :rect="domRect" /> -->

    <app-controls
      :class="{
        'ps-is-active': routerMatches('ROUTE_CONTROLS')
      }"
      @ps-dom="setActiveDom"
    ></app-controls>

    <card-list
      :class="{ 'ps-is-active': routerMatches('ROUTE_LIST') }"
    ></card-list>

    <card-details
      :class="{
        'ps-is-active': routerMatches('ROUTE_CARD'),
        'ps-is-active ps-is-peek': routerMatches('ROUTE_CARD_PEEK')
      }"
    ></card-details>

    <app-me :class="{ 'ps-is-active': routerMatches('ROUTE_ME') }"></app-me>

    <app-help
      :class="{ 'ps-is-active': routerMatches('ROUTE_HELP') }"
    ></app-help>

    <app-dots></app-dots>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState
} from '@picnic-software/vuex'
import AppControls from '@/views/AppControls'
import AppMe from '@/views/AppMe'
import AppHelp from '@/views/AppHelp'
import CardList from '@/views/CardList'
import CardDetails from '@/views/CardDetails'
import CardPeek from '@/views/CardPeek'
import AppDots from '@/views/AppDots'
import AppToaster from '@/views/AppToaster'
import DomHighlight from '@/components/DomHighlight'
import ModalHelper from '@/components/ModalHelper'
import monkeyPatchPush from '@/utils/monkey-patch-push'

import {
  APP_MODE_SITE,
  ROUTE_LOGIN,
  ROUTE_CONTROLS,
  ROUTE_CARD,
  ROUTE_CARD_DETAILS,
  ROUTE_CARD_COMMENTS,
  ROUTE_LIST,
  ROUTE_LIST_PAGE,
  ROUTE_LIST_PROJECT,
  ROUTE_ME,
  ROUTE_HELP
} from '@/common/constants'
import { providerService } from '@/api'
import '@/icons/picnic-logo'
import '@/icons/close'

export default {
  name: 'AppModeSite',
  props: {
    launchCard: {
      type: String,
      default: null
    }
  },
  components: {
    AppControls,
    DomHighlight,
    AppDots,
    AppToaster,
    CardList,
    CardDetails,
    CardPeek,
    AppMe,
    AppHelp,
    ModalHelper
  },
  data() {
    return {
      domRect: null
    }
  },
  computed: {
    ...mapState({
      page: state => state.pages.active,
      currentUser: state => state.auth.user
    }),
    ...mapGetters({
      routerMatches: 'router/matches'
    }),

    showModalHelper() {
      return (
        this.routerMatches(ROUTE_HELP) ||
        this.routerMatches(ROUTE_ME) ||
        this.routerMatches(ROUTE_LIST)
      )
    }
  },
  async mounted() {
    this.mode(APP_MODE_SITE)
    await this.findOrCreatePage()
    this.setDefaultRoute()
    this.getDotsByPage()
    this.listenForPageChanges(window.history)
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to',
      mode: 'app/mode',
      pageDotsVisible: 'pages/dots/visible'
    }),
    ...mapActions({
      findOrCreatePage: 'pages/active/findOrCreate',
      getDotsByPage: 'pages/dots/find',
      routerCard: 'router/card'
    }),

    async setDefaultRoute() {
      // Open ticket if set
      if (this.launchCard) {
        return this.routerCard({
          id: this.launchCard,
          tab: ROUTE_CARD_DETAILS
        })
      }
      return this.routerTo(ROUTE_CONTROLS)
    },

    listenForPageChanges(history) {
      if (!history) return
      monkeyPatchPush(history)
      window.onpopstate = history.onpushstate = this.handlePageChange
    },

    async handlePageChange() {
      this.pageDotsVisible(false)
      await this.routerTo(ROUTE_CONTROLS)
      await this.findOrCreatePage()
      await this.getDotsByPage()
      this.pageDotsVisible(true)
    },

    setActiveDom(rect) {
      this.domRect = rect
    }
  }
}
</script>
